<template>
  <generic-container
    :title="$t('report list')"
    icon="list"
    ref="container"
    :searchable="true"
    @filter="filter"
    :header_buttons="header_buttons"
  >
    <div class="ui dividing header">{{ $t("reports") }}</div>
    <div class="ui three cards">
      <div
        class="card"
        v-for="(item, index) in reports_by_project"
        v-bind:key="index"
      >
        <div class="content">
          <img
            class="right floated mini ui image"
            src="/images/icons/report.png"
          />
          <div class="header">{{ item.name }}</div>
          <div class="meta"></div>
          <div class="ui selection list">
            <div
              class="item"
              v-for="(rpt, idx) in item.reports"
              :key="idx"
              @click="load_report(rpt)"
            >
              <i class="text file icon"></i>
              <div class="content">
                <a class="header">{{ rpt.name }}</a>
                <div class="description">{{ rpt.description }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </generic-container>
</template>

<script>
import { local_api } from "@/utils";
import { cloneDeep, groupBy } from "lodash";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";

export default {
  name: "NgineDashboardList",
  components: { GenericContainer },
  filters: filters,
  data() {
    return {
      reports_by_project: [],
      all_reports_by_project: [],
      header_buttons: [
        {
          icon: "green plus",
          click: this.create_report,
          tooltip: this.$t("create report")
        }
      ]
    };
  },
  methods: {
    load_report(report) {
      this.$emit("load_report", report);
      this.$refs.container.toggle();
    },
    filter(filter) {
      // console.log(filter);
      if (filter == "")
        this.reports_by_project = cloneDeep(this.all_reports_by_project);
      else
        this.reports_by_project = this.all_reports_by_project.filter(
          (n) =>
            n.name.toUpperCase().includes(filter.toUpperCase()) ||
            n.reports.find((r) =>
              r.name.toUpperCase().includes(filter.toUpperCase())
            )
        );
    },
    create_report() {
      this.$emit("create_report");
      this.$refs.container.toggle();
    }
  },
  created() {
    let vm = this;
    local_api(vm, "post", "/ngine_dashboard/composer/do-get-reports")
      .then((reports) => {
        let groups = [];
        let grp = groupBy(reports, "project");
        if (grp) {
          Object.keys(grp).map((k) => {
            groups.push({ name: k, reports: grp[k] });
          });
        }
        this.$emit(
          "reports_loaded",
          groups.map((g) => {
            return g.name;
          })
        );
        this.reports_by_project = groups;
        this.all_reports_by_project = cloneDeep(groups);
      })
      .catch((err) => {
        vm.$alertify.error(JSON.stringify(err, null, 2));
      });
  },
  mounted() {}
};
</script>
